export const OBTER_NORMATIVOS = "OBTER_NORMATIVOS";
export const OBTER_NORMATIVO = "OBTER_NORMATIVO";
export const CONSULTAR_NORMATIVOS = "CONSULTAR_NORMATIVOS";
export const DEFINIR_NORMATIVOS = "DEFINIR_NORMATIVOS";
export const DEFINIR_NORMATIVO = "DEFINIR_NORMATIVO";
export const DEFINIR_FILTROS = "DEFINIR_FILTROS";
export const OBTER_FILTROS = "OBTER_FILTROS";
export const DEFINIR_FILTROS_PESQUISA = "DEFINIR_FILTROS_PESQUISA";
export const OBTER_FILTROS_PESQUISA = "OBTER_FILTROS_PESQUISA";
export const LOCAL_STORAGE_ADD = "LOCAL_STORAGE_ADD";
export const LOCAL_STORAGE_GET = "LOCAL_STORAGE_GET";
export const CLEAR_NORMATIVOS = "CLEAR_NORMATIVOS";

